import { render, staticRenderFns } from "./RouterGoProductDetailsBtn.vue?vue&type=template&id=18d50e9a"
import script from "./RouterGoProductDetailsBtn.vue?vue&type=script&lang=ts"
export * from "./RouterGoProductDetailsBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports